import {
    useViewAsPermissionGroupStore,
    type ViewAsPermissionGroup,
} from '../state/use-ui-persist';

export const useViewAs = () => {
    const viewAsPermissionGroup = useViewAsPermissionGroupStore((s) => s.value);
    const setViewAsPermissionGroup = (
        permissionGroup: ViewAsPermissionGroup
    ) => {
        useViewAsPermissionGroupStore.setState({ value: permissionGroup });
    };

    return [viewAsPermissionGroup, setViewAsPermissionGroup] as const;
};
